/* TerraDecor 3D measure preview — holographic style.
 * m²: wall surface (width × height) with a rough stone relief; its depth follows the chosen relief depth (e.g. 15–20 cm).
 * m³: a rock-like body inside the full billed block (length × height × depth).
 * Objects are transparent orange holograms with glowing contour lines; measuring lines carry flowing light.
 * It sits inside the product calculator and reads the inputs the customer already types into ([data-tdq-dim]).
 * three.js loads only when the calculator is on screen; the animation pauses when it is off screen. */
(function () {
  'use strict';
  var CFG = window.TD3D;
  if (!CFG || window.__td3d) return;
  window.__td3d = true;

  var LIB = 'https://cdn.jsdelivr.net/npm/three@0.128.0/build/three.min.js';
  var TXT = {
    sr: { load: 'Učitavanje 3D prikaza…', person: 'silueta 1,75 m', box: 'obračun: pun kvadar', view: 'Vrati pogled', drag: 'prevucite za okretanje', relief: 'reljef' },
    de: { load: '3D-Ansicht wird geladen…', person: 'Person 1,75 m', box: 'Berechnung: voller Quader', view: 'Ansicht zurücksetzen', drag: 'zum Drehen ziehen', relief: 'Relief' },
    es: { load: 'Cargando vista 3D…', person: 'persona 1,75 m', box: 'cálculo: bloque completo', view: 'Restablecer vista', drag: 'arrastre para girar', relief: 'relieve' },
    it: { load: 'Caricamento vista 3D…', person: 'persona 1,75 m', box: 'calcolo: blocco pieno', view: 'Ripristina vista', drag: 'trascina per ruotare', relief: 'rilievo' },
    fr: { load: 'Chargement de la vue 3D…', person: 'personne 1,75 m', box: 'calcul : bloc complet', view: 'Réinitialiser la vue', drag: 'glisser pour tourner', relief: 'relief' },
    en: { load: 'Loading 3D view…', person: 'person 1.75 m', box: 'billed as full block', view: 'Reset view', drag: 'drag to rotate', relief: 'relief' }
  };
  var L10N = TXT[CFG.lang] || TXT.en;
  var comma = CFG.lang !== 'en';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function fmt(n) { var s = n.toFixed(2); return comma ? s.replace('.', ',') : s; }
  function parse(v) { var n = parseFloat(String(v || '').replace(',', '.')); return isFinite(n) && n > 0 && n <= 40 ? n : null; }
  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    var calc = document.querySelector('.tdq__calc');
    if (!calc) return;
    var kind = CFG.m3 ? 'block' : 'wall';

    var css = document.createElement('style');
    css.textContent =
      '.td3d{position:relative;width:100%;aspect-ratio:16/10;max-height:270px;margin:6px 0 12px;border-radius:12px;overflow:hidden;' +
      'background:radial-gradient(90% 80% at 50% 38%,#24180d 0%,#120c07 58%,#080605 100%);border:1px solid rgba(243,154,43,.28);' +
      'box-shadow:inset 0 0 50px rgba(243,154,43,.07);touch-action:pan-y;cursor:grab;user-select:none;-webkit-user-select:none}' +
      '.td3d.is-drag{cursor:grabbing}.td3d canvas,.td3d svg{position:absolute;inset:0;width:100%;height:100%;display:block}.td3d svg{pointer-events:none}' +
      '.td3d__chip{position:absolute;left:8px;top:8px;font:500 10.5px/1.2 ui-monospace,Menlo,monospace;color:#f6dcb8;background:rgba(10,7,4,.62);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);border:1px solid rgba(243,154,43,.3);border-radius:999px;padding:4px 9px;pointer-events:none}' +
      '.td3d__reset{position:absolute;right:8px;top:8px;width:30px;height:30px;display:grid;place-items:center;color:#f6dcb8;background:rgba(10,7,4,.62);backdrop-filter:blur(6px);-webkit-backdrop-filter:blur(6px);border:1px solid rgba(243,154,43,.3);border-radius:50%;cursor:pointer;padding:0}' +
      '.td3d__reset:focus-visible{outline:2px solid #f39a2b;outline-offset:2px}' +
      '.td3d__hint{position:absolute;right:10px;bottom:8px;font-size:11px;line-height:1.2;color:rgba(246,220,184,.7);pointer-events:none;transition:opacity .4s}' +
      '.td3d__load{position:absolute;inset:0;display:grid;place-items:center;color:#a89a8b;font-size:13px}.td3d__load[hidden]{display:none}' +
      '@keyframes td3dp{0%,100%{opacity:1}50%{opacity:.35}}.td3d .td3d-miss{animation:td3dp 1.4s ease-in-out infinite}' +
      '@keyframes td3dflow{from{stroke-dashoffset:260}to{stroke-dashoffset:0}}.td3d .td3d-flow{animation:td3dflow 2.8s cubic-bezier(.45,0,.55,1) infinite}' +
      '@keyframes td3dmarch{to{stroke-dashoffset:-16}}.td3d .td3d-edge{animation:td3dmarch 1.6s linear infinite}' +
      '@media (prefers-reduced-motion:reduce){.td3d .td3d-miss,.td3d .td3d-flow,.td3d .td3d-edge{animation:none}}';
    document.head.appendChild(css);

    var box = document.createElement('div');
    box.className = 'td3d';
    box.innerHTML = '<canvas aria-hidden="true"></canvas><svg aria-hidden="true"></svg>' +
      '<div class="td3d__load">' + L10N.load + '</div>' +
      '<span class="td3d__chip">' + (kind === 'block' ? L10N.box + ' · ' : '') + L10N.person + '</span>' +
      '<button type="button" class="td3d__reset" aria-label="' + L10N.view + '" title="' + L10N.view + '"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round" style="position:static;width:14px;height:14px"><path d="M3 12a9 9 0 1 0 3-6.7"/><path d="M3 4v5h5"/></svg></button>' +
      '<span class="td3d__hint">' + L10N.drag + '</span>';
    var title = calc.querySelector('.tdq__calc-title');
    if (title && title.nextSibling) calc.insertBefore(box, title.nextSibling); else calc.insertBefore(box, calc.firstChild);

    var inputs = {};
    [].forEach.call(calc.querySelectorAll('[data-tdq-dim]'), function (i) { inputs[i.getAttribute('data-tdq-dim')] = i; });

    var started = false, visible = false;
    function start() {
      if (started) return; started = true;
      if (window.THREE) return viewer(box, inputs, kind, function () { return visible; });
      var s = document.createElement('script');
      s.src = LIB;
      s.onload = function () { viewer(box, inputs, kind, function () { return visible; }); };
      s.onerror = function () { box.hidden = true; };
      document.head.appendChild(s);
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        visible = en.some(function (e) { return e.isIntersecting; });
        if (visible) { start(); if (box.__kick) box.__kick(); }
      }, { rootMargin: '200px' }).observe(box);
    } else { visible = true; start(); }
  });

  /* ------------------------------------------------------------------ */
  var VERT = [
    'uniform float uDepth; uniform float uMode;',
    'varying vec3 vN; varying vec3 vV; varying vec3 vW; varying float vH;',
    'float hash(vec3 p){ p = fract(p * 0.3183099 + 0.1); p *= 17.0; return fract(p.x * p.y * p.z * (p.x + p.y + p.z)); }',
    'float noise(vec3 x){ vec3 i = floor(x); vec3 f = fract(x); f = f * f * (3.0 - 2.0 * f);',
    '  return mix(mix(mix(hash(i), hash(i + vec3(1.0,0.0,0.0)), f.x), mix(hash(i + vec3(0.0,1.0,0.0)), hash(i + vec3(1.0,1.0,0.0)), f.x), f.y),',
    '             mix(mix(hash(i + vec3(0.0,0.0,1.0)), hash(i + vec3(1.0,0.0,1.0)), f.x), mix(hash(i + vec3(0.0,1.0,1.0)), hash(i + vec3(1.0,1.0,1.0)), f.x), f.y), f.z); }',
    'float relief(vec2 p){ float s = 0.0, a = 0.55; p *= 1.7; for (int i = 0; i < 5; i++) { s += a * noise(vec3(p, 3.7)); p = p * 2.07 + 1.3; a *= 0.5; } return clamp((s - 0.18) * 1.45, 0.0, 1.0); }',
    'void main(){',
    '  vec4 w = modelMatrix * vec4(position, 1.0);',
    '  vec3 n = normalize(mat3(modelMatrix) * normal);',
    '  if (uMode > 0.5) {',
    '    float h = relief(w.xy); vH = h;',
    '    w.z += h * uDepth;',
    '    float e = 0.015; float hx = relief(w.xy + vec2(e, 0.0)); float hy = relief(w.xy + vec2(0.0, e));',
    '    n = normalize(vec3(-(hx - h) / e * uDepth, -(hy - h) / e * uDepth, 1.0));',
    '  } else { vH = w.y; }',
    '  vW = w.xyz; vN = n; vV = normalize(cameraPosition - w.xyz);',
    '  gl_Position = projectionMatrix * viewMatrix * w;',
    '}'
  ].join('\n');
  var FRAG = [
    'uniform vec3 uColor; uniform float uTime; uniform float uDensity; uniform float uOpacity; uniform float uScan; uniform float uLines;',
    'varying vec3 vN; varying vec3 vV; varying vec3 vW; varying float vH;',
    'void main(){',
    '  float fr = pow(1.0 - abs(dot(normalize(vN), normalize(vV))), 2.2);',
    '  float y = vH * uDensity - uTime * 0.12;',
    '  float q = 0.5 - abs(fract(y) - 0.5);',
    '  float fw = max(fwidth(y), 0.0001);',
    '  float line = (1.0 - smoothstep(0.0, fw * 1.4, q)) * uLines;',
    '  float sb = abs(fract(vW.y * 0.32 - uTime * 0.16) - 0.5);',
    '  float scan = (1.0 - smoothstep(0.0, 0.07, sb)) * uScan;',
    '  vec3 col = uColor * (0.22 + fr * 1.5 + line * 0.95) + vec3(1.0, 0.86, 0.62) * scan * 0.35;',
    '  float a = clamp(0.045 + fr * 0.75 + line * 0.5 + scan * 0.2, 0.0, 1.0) * uOpacity;',
    '  gl_FragColor = vec4(col, a);',
    '}'
  ].join('\n');

  function viewer(box, inputs, kind, isVisible) {
    var T = window.THREE;
    var canvas = box.querySelector('canvas'), ov = box.querySelector('svg'), loadEl = box.querySelector('.td3d__load');
    var renderer;
    try { renderer = new T.WebGLRenderer({ canvas: canvas, antialias: true, alpha: true, powerPreference: 'high-performance' }); }
    catch (e) { box.hidden = true; return; }
    renderer.setPixelRatio(Math.min(window.devicePixelRatio || 1, 2));
    var scene = new T.Scene();
    var camera = new T.PerspectiveCamera(30, 1.6, 0.05, 200);

    function holo(color, density, opacity, mode, scan) {
      return new T.ShaderMaterial({
        uniforms: { uColor: { value: new T.Color(color) }, uTime: { value: 0 }, uDensity: { value: density }, uOpacity: { value: opacity }, uDepth: { value: 0.05 }, uMode: { value: mode }, uScan: { value: scan }, uLines: { value: density > 0 ? 1 : 0 } },
        vertexShader: VERT, fragmentShader: FRAG,
        transparent: true, depthWrite: false, side: T.DoubleSide, blending: T.AdditiveBlending,
        extensions: { derivatives: true }
      });
    }
    var mats = [];

    /* floor grid */
    var grid = new T.GridHelper(30, 60, 0xf39a2b, 0xf39a2b);
    grid.material.transparent = true; grid.material.opacity = 0.07; grid.material.depthWrite = false;
    scene.add(grid);

    /* person for scale */
    var personMat = holo(0xcdb79a, 9, 0.55, 0, 0); mats.push(personMat);
    var person = (function () {
      var g = new T.Group();
      function cyl(rt, rb, h, x, y, rz) { var c = new T.Mesh(new T.CylinderGeometry(rt, rb, h, 24), personMat); c.position.set(x, y, 0); if (rz) c.rotation.z = rz; g.add(c); }
      cyl(0.058, 0.045, 0.86, -0.075, 0.43); cyl(0.058, 0.045, 0.86, 0.075, 0.43);
      cyl(0.18, 0.135, 0.6, 0, 1.16); cyl(0.04, 0.034, 0.6, -0.225, 1.15, 0.06); cyl(0.04, 0.034, 0.6, 0.225, 1.15, -0.06);
      cyl(0.045, 0.05, 0.09, 0, 1.5);
      var head = new T.Mesh(new T.SphereGeometry(0.1, 28, 20), personMat); head.position.y = 1.64; head.scale.set(0.88, 1.12, 0.98); g.add(head);
      return g;
    })();
    scene.add(person);

    /* product body */
    var wallMat, wallFace, wallBack, rock, rockMat;
    if (kind === 'wall') {
      wallMat = holo(0xf39a2b, 11, 1, 1, 1); mats.push(wallMat);
      var pg = new T.PlaneGeometry(1, 1, 160, 120); pg.translate(0.5, 0.5, 0);
      wallFace = new T.Mesh(pg, wallMat); scene.add(wallFace);
      var backMat = holo(0xf39a2b, 0, 0.35, 0, 0); mats.push(backMat);
      var bg = new T.PlaneGeometry(1, 1); bg.translate(0.5, 0.5, 0);
      wallBack = new T.Mesh(bg, backMat); scene.add(wallBack);
    } else {
      rockMat = holo(0xf39a2b, 7, 1, 0, 1); mats.push(rockMat);
      rock = new T.Mesh(rockGeometry(T), rockMat); scene.add(rock);
    }

    /* relief depth from the chosen variant (e.g. "15–20 cm") */
    var reliefLabel = '', reliefM = 0.05;
    function readRelief() {
      var el = document.querySelector('[data-tdq-variant]');
      var t = el ? el.textContent : '';
      if (!t) { var chk = document.querySelector('variant-picker input:checked'); t = chk ? chk.value : ''; }
      var m = String(t).match(/(\d+(?:[.,]\d+)?)\s*(?:[–-]\s*(\d+(?:[.,]\d+)?))?\s*cm/i);
      if (m) { var v = parseFloat((m[2] || m[1]).replace(',', '.')); reliefM = Math.max(0.02, v / 100); reliefLabel = m[0].replace(/\s+/g, ' ').trim(); }
    }
    readRelief();
    var varEl = document.querySelector('[data-tdq-variant]');
    if (varEl && window.MutationObserver) new MutationObserver(function () { readRelief(); kick(); }).observe(varEl, { childList: true, characterData: true, subtree: true });
    document.addEventListener('change', function () { setTimeout(function () { readRelief(); kick(); }, 60); });

    function layout(D, miss) {
      var pts = [], dims = [], edges = null, gh = miss.length > 0;
      function has(k) { return miss.indexOf(k) > -1; }
      if (kind === 'wall') {
        var W = D.w, H = D.h, dep = D.r;
        wallFace.scale.set(W, H, 1);
        wallBack.scale.set(W, H, 1); wallBack.position.z = -0.03;
        wallMat.uniforms.uDepth.value = dep;
        wallMat.uniforms.uOpacity.value = gh ? 0.45 : 1;
        person.position.set(W + 0.75, 0, 0.85); person.rotation.y = -0.45;
        edges = [[0, 0, -0.03], [W, H, dep]];
        pts.push([0, 0, 0], [W, H, dep], [W + 1.05, 1.8, 0.85], [0, 0, 0.6], [W, 0, 0.6]);
        dims.push({ a: [0, 0, dep + 0.02], b: [W, 0, dep + 0.02], o: [0, 0, 0.6], v: W, miss: has('w') });
        dims.push({ a: [0, 0, dep + 0.02], b: [0, H, dep + 0.02], o: [-0.45, 0, 0], v: H, miss: has('h') });
        if (reliefLabel) dims.push({ a: [W, H, -0.03], b: [W, H, dep], o: [0.32, 0.18, 0], label: L10N.relief + ' ' + reliefLabel, thin: true });
      } else {
        var Lb = D.l, Hb = D.h, Db = D.d;
        rock.scale.set(Lb, Hb, Db);
        rockMat.uniforms.uOpacity.value = gh ? 0.45 : 1;
        person.position.set(Lb + 0.8, 0, Db * 0.6); person.rotation.y = -0.5;
        edges = [[0, 0, 0], [Lb, Hb, Db]];
        pts.push([0, 0, 0], [Lb, Hb, Db], [Lb + 1.1, 1.8, Db * 0.6], [Lb + 0.9, 0, Db * 0.6]);
        dims.push({ a: [0, 0, Db], b: [Lb, 0, Db], o: [0, 0, 0.55], v: Lb, miss: has('l') });
        dims.push({ a: [0, 0, Db], b: [0, Hb, Db], o: [-0.5, 0, 0], v: Hb, miss: has('h') });
        dims.push({ a: [Lb, 0, 0], b: [Lb, 0, Db], o: [0.5, 0, 0], v: Db, miss: has('d') });
      }
      dims.forEach(function (d) { pts.push(add(d.a, mul(d.o, 1.45)), add(d.b, mul(d.o, 1.45))); });
      return { pts: pts, dims: dims, edges: edges };
    }
    function add(a, b) { return [a[0] + b[0], a[1] + b[1], a[2] + b[2]]; }
    function mul(a, k) { return [a[0] * k, a[1] * k, a[2] * k]; }

    /* camera: fits everything, eased; drag to orbit */
    var BASE = kind === 'wall' ? [0.55, 0.2] : [0.62, 0.32];
    var yawOff = 0, pitchOff = 0, curYaw = null, curPitch = null, cam = { c: new T.Vector3(), d: 6 };
    function frameCamera(pts, snap) {
      var V3 = pts.map(function (q) { return new T.Vector3(q[0], q[1], q[2]); });
      var sph = new T.Box3().setFromPoints(V3).getBoundingSphere(new T.Sphere());
      var vf = camera.fov * Math.PI / 180, hf = 2 * Math.atan(Math.tan(vf / 2) * camera.aspect);
      var ty = BASE[0] + yawOff, tp = Math.max(-0.1, Math.min(0.85, BASE[1] + pitchOff)), k = snap || reduce ? 1 : 0.2;
      if (curYaw === null) { curYaw = ty; curPitch = tp; }
      curYaw += (ty - curYaw) * k; curPitch += (tp - curPitch) * k;
      var dir = new T.Vector3(Math.sin(curYaw) * Math.cos(curPitch), Math.sin(curPitch), Math.cos(curYaw) * Math.cos(curPitch));
      var tgt = sph.center.clone(), dist = sph.radius / Math.sin(Math.min(vf, hf) / 2), probe = camera.clone();
      for (var it = 0; it < 3; it++) {
        probe.position.copy(tgt).addScaledVector(dir, dist); probe.lookAt(tgt); probe.updateMatrixWorld();
        var mnx = 9, mny = 9, mxx = -9, mxy = -9;
        V3.forEach(function (v) { var q = v.clone().project(probe); mnx = Math.min(mnx, q.x); mxx = Math.max(mxx, q.x); mny = Math.min(mny, q.y); mxy = Math.max(mxy, q.y); });
        var hh = Math.tan(vf / 2) * dist, hw = hh * camera.aspect;
        var right = new T.Vector3().setFromMatrixColumn(probe.matrixWorld, 0), up = new T.Vector3().setFromMatrixColumn(probe.matrixWorld, 1);
        tgt.addScaledVector(right, (mnx + mxx) / 2 * hw).addScaledVector(up, (mny + mxy) / 2 * hh);
        dist *= Math.max((mxx - mnx) / 2 / 0.9, (mxy - mny) / 2 / 0.8);
      }
      var ck = snap || reduce ? 1 : 0.16;
      cam.c.lerp(tgt, ck); cam.d += (dist - cam.d) * ck;
      camera.position.copy(cam.c).addScaledVector(dir, cam.d); camera.lookAt(cam.c);
      grid.position.set(cam.c.x, 0, cam.c.z);
      return Math.abs(dist - cam.d) > 0.003 || cam.c.distanceTo(tgt) > 0.003 || Math.abs(ty - curYaw) > 0.001 || Math.abs(tp - curPitch) > 0.001;
    }

    /* SVG overlay: glowing block edges and measuring lines with flowing light */
    var NS = 'http://www.w3.org/2000/svg', vw = 1, vh = 1;
    function E(n, a, p) { var e = document.createElementNS(NS, n); for (var k in a) e.setAttribute(k, a[k]); if (p) p.appendChild(e); return e; }
    function scr(q) { var v = new T.Vector3(q[0], q[1], q[2]).project(camera); return [(v.x + 1) / 2 * vw, (1 - v.y) / 2 * vh]; }
    function overlay(info) {
      while (ov.firstChild) ov.removeChild(ov.firstChild);
      ov.setAttribute('viewBox', '0 0 ' + vw + ' ' + vh);
      var defs = E('defs', {}, ov);
      var f = E('filter', { id: 'td3dGlow', x: '-50%', y: '-50%', width: '200%', height: '200%' }, defs);
      E('feGaussianBlur', { stdDeviation: '2.6', result: 'b' }, f);
      var fm = E('feMerge', {}, f); E('feMergeNode', { in: 'b' }, fm); E('feMergeNode', { in: 'b' }, fm); E('feMergeNode', { in: 'SourceGraphic' }, fm);
      var gr = E('linearGradient', { id: 'td3dPill', x1: 0, y1: 0, x2: 1, y2: 1 }, defs);
      E('stop', { offset: '0', 'stop-color': '#24180d' }, gr); E('stop', { offset: '1', 'stop-color': '#0a0705' }, gr);
      if (info.edges) {
        var a0 = info.edges[0], a1 = info.edges[1];
        var c = [[a0[0], a0[1], a0[2]], [a1[0], a0[1], a0[2]], [a1[0], a0[1], a1[2]], [a0[0], a0[1], a1[2]], [a0[0], a1[1], a0[2]], [a1[0], a1[1], a0[2]], [a1[0], a1[1], a1[2]], [a0[0], a1[1], a1[2]]].map(scr);
        var ge = E('g', { stroke: '#ffb054', 'stroke-width': 1.3, fill: 'none', filter: 'url(#td3dGlow)', 'stroke-linecap': 'round' }, ov);
        [[0, 1], [1, 2], [2, 3], [3, 0], [4, 5], [5, 6], [6, 7], [7, 4], [0, 4], [1, 5], [2, 6], [3, 7]].forEach(function (e, i) {
          var back = e[0] === 0 || e[1] === 0;
          E('line', { x1: c[e[0]][0], y1: c[e[0]][1], x2: c[e[1]][0], y2: c[e[1]][1], opacity: back ? 0.3 : 0.85, 'stroke-dasharray': kind === 'block' ? '5 3' : 'none', class: kind === 'block' ? 'td3d-edge' : '' }, ge);
          if (!back) {
            var fl = E('line', { x1: c[e[0]][0], y1: c[e[0]][1], x2: c[e[1]][0], y2: c[e[1]][1], stroke: '#fff0d6', 'stroke-width': 2, pathLength: 260, 'stroke-dasharray': '26 234', class: 'td3d-flow', opacity: 0.85 }, ge);
            fl.style.animationDelay = (i * -0.47) + 's';
          }
        });
      }
      info.dims.forEach(function (d, idx) {
        var col = d.miss ? '#ff7a59' : '#f39a2b';
        var a = scr(d.a), b = scr(d.b), a2 = scr(add(d.a, d.o)), b2 = scr(add(d.b, d.o));
        var g = E('g', { stroke: col, fill: 'none', 'stroke-linecap': 'round' }, ov);
        if (!d.thin) {
          var ae = scr(add(d.a, mul(d.o, 1.15))), be = scr(add(d.b, mul(d.o, 1.15)));
          E('line', { x1: a[0], y1: a[1], x2: ae[0], y2: ae[1], 'stroke-width': 1, opacity: 0.7 }, g);
          E('line', { x1: b[0], y1: b[1], x2: be[0], y2: be[1], 'stroke-width': 1, opacity: 0.7 }, g);
          var ln = E('line', { x1: a2[0], y1: a2[1], x2: b2[0], y2: b2[1], 'stroke-width': 1.8, filter: 'url(#td3dGlow)' }, g);
          if (d.miss) ln.setAttribute('stroke-dasharray', '6 5');
          else {
            var fl = E('line', { x1: a2[0], y1: a2[1], x2: b2[0], y2: b2[1], stroke: '#fff1d8', 'stroke-width': 2.4, pathLength: 260, 'stroke-dasharray': '34 226', filter: 'url(#td3dGlow)', class: 'td3d-flow' }, g);
            fl.style.animationDelay = (idx * -0.9) + 's';
          }
          var ux = b2[0] - a2[0], uy = b2[1] - a2[1], ul = Math.hypot(ux, uy) || 1; ux /= ul; uy /= ul;
          var tx = (ux - uy) * 0.7071 * 6, ty = (ux + uy) * 0.7071 * 6;
          [a2, b2].forEach(function (q) {
            E('line', { x1: q[0] - tx, y1: q[1] - ty, x2: q[0] + tx, y2: q[1] + ty, 'stroke-width': 2.2 }, g);
            E('circle', { cx: q[0], cy: q[1], r: 2.2, fill: col, stroke: 'none', filter: 'url(#td3dGlow)' }, g);
          });
        } else {
          var mid = scr([(d.a[0] + d.b[0]) / 2, (d.a[1] + d.b[1]) / 2, (d.a[2] + d.b[2]) / 2]);
          var lp = scr(add([(d.a[0] + d.b[0]) / 2, (d.a[1] + d.b[1]) / 2, (d.a[2] + d.b[2]) / 2], d.o));
          E('line', { x1: mid[0], y1: mid[1], x2: lp[0], y2: lp[1], 'stroke-width': 1, opacity: 0.75 }, g);
          E('circle', { cx: mid[0], cy: mid[1], r: 2.4, fill: col, stroke: 'none', filter: 'url(#td3dGlow)' }, g);
          a2 = lp; b2 = lp;
        }
        var txt = d.label || (d.miss ? '? m' : fmt(d.v) + ' m'), w = txt.length * 7.2 + 18, mx = (a2[0] + b2[0]) / 2, my = (a2[1] + b2[1]) / 2;
        mx = Math.max(w / 2 + 4, Math.min(vw - w / 2 - 4, mx)); my = Math.max(16, Math.min(vh - 16, my));
        var lg = E('g', { transform: 'translate(' + mx.toFixed(1) + ' ' + my.toFixed(1) + ')' }, ov);
        if (d.miss) lg.setAttribute('class', 'td3d-miss');
        E('rect', { x: -w / 2, y: -11.5, width: w, height: 23, rx: 11.5, fill: 'none', stroke: col, 'stroke-width': 2, opacity: 0.55, filter: 'url(#td3dGlow)' }, lg);
        E('rect', { x: -w / 2, y: -11.5, width: w, height: 23, rx: 11.5, fill: 'url(#td3dPill)', stroke: col, 'stroke-width': 1.2 }, lg);
        var t = E('text', { x: 0, y: 4.3, 'text-anchor': 'middle', fill: d.miss ? '#ff9a80' : '#ffe3bf', 'font-family': 'ui-monospace,Menlo,Consolas,monospace', 'font-size': 12, 'font-weight': 600 }, lg);
        t.textContent = txt;
      });
    }

    /* loop: eases sizes, re-frames the camera, animates the hologram while on screen */
    var DEF = kind === 'wall' ? { w: 3.2, h: 2.6 } : { l: 1.8, h: 1.1, d: 1.0 };
    var cur = null, first = true, dragging = false, dirty = true, last = 0, t0 = performance.now(), raf = 0;
    function targets() {
      var out = {}, miss = [];
      Object.keys(DEF).forEach(function (k) { var n = inputs[k] ? parse(inputs[k].value) : null; if (n === null) { miss.push(k); out[k] = DEF[k]; } else out[k] = n; });
      if (kind === 'wall') out.r = reliefM;
      return { dims: out, miss: miss };
    }
    function resize() {
      var r = box.getBoundingClientRect();
      vw = Math.max(1, r.width); vh = Math.max(1, r.height);
      renderer.setSize(vw, vh, false);
      camera.aspect = vw / vh; camera.updateProjectionMatrix();
      dirty = true;
    }
    function frame(now) {
      raf = 0;
      if (!isVisible() || document.hidden) return;
      raf = requestAnimationFrame(frame);
      if (now - last < 30 && !dirty && !dragging) return;
      last = now;
      var t = targets(), moving = false;
      if (!cur) cur = Object.assign({}, t.dims);
      Object.keys(t.dims).forEach(function (k) { var d = t.dims[k] - cur[k]; if (Math.abs(d) > 0.0005 && !reduce) { cur[k] += d * 0.18; moving = true; } else cur[k] = t.dims[k]; });
      var info = layout(cur, t.miss);
      if (frameCamera(info.pts, first)) moving = true;
      first = false;
      var time = reduce ? 0 : (now - t0) / 1000;
      mats.forEach(function (m) { m.uniforms.uTime.value = time; });
      renderer.render(scene, camera);
      if (moving || dirty || dragging) overlay(info);
      dirty = moving;
    }
    function kick() { dirty = true; if (!raf) raf = requestAnimationFrame(frame); }
    box.__kick = kick;
    document.addEventListener('visibilitychange', kick);
    Object.keys(inputs).forEach(function (k) { inputs[k].addEventListener('input', kick); inputs[k].addEventListener('change', kick); });

    var sx = 0, sy = 0, sYaw = 0, sPitch = 0, decided = false, hint = box.querySelector('.td3d__hint');
    box.addEventListener('pointerdown', function (e) {
      if (e.target.closest('.td3d__reset')) return;
      dragging = true; decided = e.pointerType === 'mouse'; sx = e.clientX; sy = e.clientY; sYaw = yawOff; sPitch = pitchOff;
      box.classList.add('is-drag'); kick();
    });
    window.addEventListener('pointermove', function (e) {
      if (!dragging) return;
      var dx = e.clientX - sx, dy = e.clientY - sy;
      if (!decided) {
        if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
        if (Math.abs(dy) > Math.abs(dx)) { dragging = false; box.classList.remove('is-drag'); return; }
        decided = true;
      }
      yawOff = Math.max(-1.2, Math.min(1.2, sYaw + dx / vw * 2.6));
      if (e.pointerType === 'mouse') pitchOff = Math.max(-0.3, Math.min(0.5, sPitch + dy / vh * 1.2));
      if (hint) hint.style.opacity = '0';
      dirty = true;
    });
    window.addEventListener('pointerup', function () { if (dragging) { dragging = false; box.classList.remove('is-drag'); kick(); } });
    box.querySelector('.td3d__reset').addEventListener('click', function () { yawOff = 0; pitchOff = 0; kick(); });
    if (window.ResizeObserver) new ResizeObserver(function () { resize(); kick(); }).observe(box);
    resize();
    loadEl.hidden = true;
    kick();
  }

  /* rock-like body: rounded block with natural relief, normalised to a 1×1×1 box */
  function rockGeometry(T) {
    function hash(x, y, z) { var h = Math.imul(x, 374761393) ^ Math.imul(y, 668265263) ^ Math.imul(z, 1274126177); h = Math.imul(h ^ (h >>> 13), 1274126177); h ^= h >>> 16; return (h >>> 0) / 4294967296; }
    function vnoise(x, y, z) {
      var xi = Math.floor(x), yi = Math.floor(y), zi = Math.floor(z), xf = x - xi, yf = y - yi, zf = z - zi;
      var u = xf * xf * (3 - 2 * xf), v = yf * yf * (3 - 2 * yf), w = zf * zf * (3 - 2 * zf);
      function L(a, b, t) { return a + (b - a) * t; }
      return L(L(L(hash(xi, yi, zi), hash(xi + 1, yi, zi), u), L(hash(xi, yi + 1, zi), hash(xi + 1, yi + 1, zi), u), v),
        L(L(hash(xi, yi, zi + 1), hash(xi + 1, yi, zi + 1), u), L(hash(xi, yi + 1, zi + 1), hash(xi + 1, yi + 1, zi + 1), u), v), w);
    }
    function fbm(x, y, z, o) { var a = 0.5, f = 1, s = 0; for (var i = 0; i < o; i++) { s += a * (vnoise(x * f + 17.3 * i, y * f, z * f) * 2 - 1); f *= 2.07; a *= 0.5; } return s; }
    var g = new T.SphereGeometry(1, 160, 110), pos = g.attributes.position, n = pos.count;
    for (var i = 0; i < n; i++) {
      var x = pos.getX(i), y = pos.getY(i), z = pos.getZ(i);
      var sq = 1 / Math.pow(Math.pow(Math.abs(x), 4) + Math.pow(Math.abs(y), 4) + Math.pow(Math.abs(z), 4), 0.25);
      var r = (sq * 0.55 + 0.45) * (1 + fbm(x * 1.2 + 3, y * 1.2, z * 1.2, 3) * 0.16 + (1 - Math.abs(fbm(x * 2.8, y * 2.8 + 5, z * 2.8, 4))) * 0.06 + fbm(x * 7, y * 7, z * 7, 3) * 0.022);
      pos.setXYZ(i, x * r, Math.max(y * r, -0.62), z * r);
    }
    g.computeBoundingBox();
    var bb = g.boundingBox, sz = new T.Vector3(); bb.getSize(sz);
    for (var k = 0; k < n; k++) pos.setXYZ(k, (pos.getX(k) - bb.min.x) / sz.x, (pos.getY(k) - bb.min.y) / sz.y, (pos.getZ(k) - bb.min.z) / sz.z);
    g.computeVertexNormals();
    var nor = g.attributes.normal, map = {};
    for (var a = 0; a < n; a++) { var kk = Math.round(pos.getX(a) * 1e4) + '_' + Math.round(pos.getY(a) * 1e4) + '_' + Math.round(pos.getZ(a) * 1e4); (map[kk] = map[kk] || []).push(a); }
    Object.keys(map).forEach(function (kk) {
      var ids = map[kk]; if (ids.length < 2) return;
      var s = [0, 0, 0]; ids.forEach(function (id) { s[0] += nor.getX(id); s[1] += nor.getY(id); s[2] += nor.getZ(id); });
      var l = Math.hypot(s[0], s[1], s[2]) || 1; ids.forEach(function (id) { nor.setXYZ(id, s[0] / l, s[1] / l, s[2] / l); });
    });
    return g;
  }
})();
